import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import '@fontsource-variable/noto-sans/wdth.css'
import '@/style/global.scss'

import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import messages from '@intlify/unplugin-vue-i18n/messages'

import 'maplibre-gl/dist/maplibre-gl.css'
// import VueMaplibreGl from '@indoorequal/vue-maplibre-gl'

const i18n = createI18n({
  legacy: false,
  locale: 'pl',
  fallbackLocale: 'en',
  messages,
  datetimeFormats: {
    en: {
      weekday: {
        weekday: 'short',
      },
      hourMinuteSecond: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      },
      hourAndMinute: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      },
      monthAndDay: {
        day: '2-digit',
        month: '2-digit',
      },
      time: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      },
      date: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      weekdayAndDate: {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      monthShort: {
        month: 'short',
      },
      yearShort: {
        year: '2-digit',
      },
    },
    pl: {
      weekday: {
        weekday: 'short',
      },
      hourMinuteSecond: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      },
      hourAndMinute: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      },
      monthAndDay: {
        day: '2-digit',
        month: '2-digit',
      },
      time: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      },
      date: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      weekdayAndDate: {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      monthShort: {
        month: 'short',
      },
      yearShort: {
        year: '2-digit',
      },
    },
  },
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(VueQueryPlugin)

app.mount('#app')
